import React from "react";
import { ArrowDownRight } from "lucide-react";

const HERO_IMG = "/images/img.png";

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-32 pb-12 md:pb-16 overflow-hidden bg-white"
    >
      <div className="px-6 md:px-12 lg:px-16 grid grid-cols-12 gap-6 items-end">
        {/* Headline */}
        <div className="col-span-12 lg:col-span-8">
          <p
            data-testid="hero-overline"
            className="flex items-center gap-2 text-[12px] tracking-[0.28em] uppercase font-bold text-[#E60000] mb-6 md:mb-10"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#E60000]" />
            Marketing · Content · Influencers
          </p>
          <h1
            data-testid="hero-headline"
            aria-label="Best Branding Agency in Hyderabad — We're the dot to your marketing. Everything ends here."
            className="font-display font-black uppercase text-[44px] leading-[0.92] sm:text-[64px] md:text-[88px] lg:text-[112px] xl:text-[132px] tracking-[-0.04em] text-black text-balance"
          >
            We're the dot
            <br />
            to your
            <br />
            <span className="font-serif-italic font-normal lowercase tracking-tight text-black/85">
              marketing
            </span>
            <span className="text-[#E60000]">.</span>
            <br />
            Everything
            <br />
            ends here
            <span className="text-[#E60000]">.</span>
          </h1>
        </div>

        {/* Right: Visual + descriptor */}
        <div className="col-span-12 lg:col-span-4 flex flex-col gap-6 md:gap-8 lg:pl-8">
          <div className="relative aspect-square w-full max-w-[420px] ml-auto">
            <div className="absolute inset-0 bg-[#FFE5E5]" />
            <img
              src={HERO_IMG}
              alt="Dot Media — Best Branding Agency in Hyderabad"
              data-testid="hero-image"
              className="relative z-10 w-full h-full object-cover mix-blend-multiply"
            />
            <div className="absolute -bottom-3 -right-3 z-20 bg-[#E60000] text-white text-[10px] tracking-[0.22em] uppercase font-bold px-3 py-2">
              The Dot Media
            </div>
          </div>
        </div>
      </div>

      {/* Sub-line + CTA row */}
      <div className="px-6 md:px-12 lg:px-16 mt-12 md:mt-16 grid grid-cols-12 gap-6 items-end border-t border-black/15 pt-8 md:pt-10">
        <div className="col-span-12 md:col-span-7 lg:col-span-6">
          <p
            data-testid="hero-subline"
            className="text-base md:text-lg leading-relaxed text-[#333] max-w-2xl"
          >
            End-to-end marketing, content, and influencer solutions — designed
            to{" "}
            <em className="font-serif-italic not-italic text-black">build</em>,{" "}
            <em className="font-serif-italic not-italic text-black">scale</em>,
            and{" "}
            <em className="font-serif-italic not-italic text-black">
              position
            </em>{" "}
            your brand with clarity and impact.
          </p>
        </div>

        <div className="col-span-12 md:col-span-5 lg:col-span-6 flex md:justify-end items-end gap-4">
          <a
            href="#services"
            data-testid="hero-cta-primary"
            className="group inline-flex items-center gap-3 bg-[#E60000] hover:bg-[#CC0000] text-white px-6 md:px-8 py-4 md:py-5 text-[12px] md:text-[13px] tracking-[0.22em] uppercase font-bold transition-colors duration-200"
          >
            Check our services
            <ArrowDownRight
              size={18}
              className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1"
            />
          </a>
          <a
            href="#campaigns"
            data-testid="hero-cta-secondary"
            className="hidden sm:inline-flex items-center gap-2 text-[12px] tracking-[0.22em] uppercase font-bold text-black border-b-2 border-black hover:text-[#E60000] hover:border-[#E60000] transition-colors duration-200 pb-1"
          >
            See the work
          </a>
        </div>
      </div>

      {/* Scrolling tagline */}
      <div className="mt-14 md:mt-20 border-y border-black/15 py-4 md:py-5 overflow-hidden">
        <div className="marquee-track">
          {Array.from({ length: 8 }).map((_, i) => (
            <span
              key={i}
              className="font-display font-black uppercase tracking-tight text-[36px] md:text-[56px] leading-none px-6 flex items-center gap-6"
            >
              Strategy
              <span className="w-2 h-2 rounded-full bg-[#E60000]" />
              Content
              <span className="w-2 h-2 rounded-full bg-black" />
              Influence
              <span className="w-2 h-2 rounded-full bg-[#E60000]" />
              Production
              <span className="w-2 h-2 rounded-full bg-black" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
